<div class="row gx-2">
  @if (dateFormat === 'YMD') {
    <ng-container *ngTemplateOutlet="year"></ng-container>
  }

  <div class="col-7">
    <select
      appFormControl
      [ngModel]="selectedMonthValue"
      (ngModelChange)="onMonthChanged($event)"
      [disabled]="disabled"
      (blur)="onTouched(0)"
    >
      @for (date of formattedDates; track date) {
        <option [value]="date.value">
          {{ getDisplayLabel(date) }}
        </option>
      }
    </select>
  </div>

  @if (dateFormat !== 'YMD') {
    <ng-container *ngTemplateOutlet="year"></ng-container>
  }

  <ng-template #year>
    <div class="col-5">
      <input
        type="number"
        appFormControl
        placeholder="Year"
        [ngModel]="selectedYearValue"
        (ngModelChange)="onYearChanged($event)"
        [disabled]="disabled"
        (blur)="onTouched(1)"
      />
    </div>
  </ng-template>
</div>
<ng-content></ng-content>
